import { render, staticRenderFns } from "./ListPurchase.vue?vue&type=template&id=0c74e786"
import script from "./ListPurchase.vue?vue&type=script&lang=js"
export * from "./ListPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports